import { render, staticRenderFns } from "./AmongDetail.vue?vue&type=template&id=7cd72311&scoped=true&"
import script from "./AmongDetail.vue?vue&type=script&lang=js&"
export * from "./AmongDetail.vue?vue&type=script&lang=js&"
import style0 from "./AmongDetail.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./AmongDetail.vue?vue&type=style&index=1&id=7cd72311&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd72311",
  null
  
)

export default component.exports